// src/features/appStructure/queries.ts
import { queryOptions } from "@tanstack/react-query"
import { requestApi2 } from "@utils/http"
import { AppStructure, endpoints } from "api"
import { expandAppStructurePayload } from "./expandAppStructurePayload"

export const APP_STRUCTURE_QUERY_KEY = ["appStructure"]
export async function fetchAppStructure(signal?: AbortSignal): Promise<AppStructure | null> {
	const data = await requestApi2(endpoints.getAppStructure, undefined, signal)

	// if (data == null) {
	// 	// Prefer throwing: React Query treats it as error and you can show UI accordingly
	// 	throw new Error("Server error: appStructure is null")
	// }

	return data == null ? null : expandAppStructurePayload(data)
}

export const appStructureQueryOptions = () =>
	queryOptions({
		queryKey: APP_STRUCTURE_QUERY_KEY,
		queryFn: ({ signal }) => fetchAppStructure(signal),
		staleTime: 5 * 60 * 1000, // adjust: how often it can be considered fresh
		gcTime: 30 * 60 * 1000, // (aka cacheTime in older versions)
		retry: 2,
	})
